import React from "react";
import RegisterCallout from "../components/RegisterCallout";
import Speakers, { SpeakerCardSlider } from "../components/Speakers";
import Banner from "../components/Banner";
import SpeakerData27 from "../data/SpeakerData27";
import SpeakerData25 from "../data/SpeakerData25";

export default function PageSpeakers() {
  return (
    <>
      <Banner
        leftImage="img/bg-banner-round-gradient.webp"
        className="bg-after-purple"
      >
        <div className="col-12 col-md-8">
          <div className="row">
            <div className="col-12 mb-3">
              <div className="display-1 color-white">Featured Speakers</div>
            </div>
            <div className="col-12 col-md-11 col-lg-10 col-xl-9 mb-2">
              <div style={{ maxWidth: "36em" }}>
                <p className="color-white mb-0">
                  Gain insights from a hand-selected group of the brightest
                  minds in compensation and finance who are transforming the
                  future of <span className="nobr">the industry.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-4 text-end px-0 pb-4 d-none d-md-block">
          <img
            className="img-fluid"
            src="../img/logo-certs.webp"
            alt="HRCI and SHRM certifications"
          />
        </div>
      </Banner>

      <section className="speakers bg-red-purple-top-right">
        <div
          className="container"
          style={{ maxWidth: "90em", margin: "0 auto" }}
        >
          <div className="row keynote-speaker-row">
            <Speakers
              filter="keynote"
              speakers={SpeakerData27}
              verticalOffset
              colWidth="6"
            />
          </div>

          <div className="row speaker-row">
            <Speakers
              filter="non-keynote"
              speakers={SpeakerData27}
              verticalOffset
              colWidth="4"
            />
          </div>
        </div>
      </section>

      <section className="past-presentations">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1 className="color-purple mb-5">
                Watch the 2025 Presentations
              </h1>

              <SpeakerCardSlider data={SpeakerData25} />
            </div>
          </div>
        </div>
      </section>

      <RegisterCallout className="bg-before-white" />
    </>
  );
}
